<div class="row pagination-wrap align-items-center">
  <div class="col-12 col-sm-4 col-md-3 gotopage">
    <label *ngIf="totalPages > limit">Page no.:&nbsp;</label>
    <input
    #pageInput
    type="number"
    class="form-control"
    placeholder="No."
    style="width: 100px; border:solid 1px rgba(109, 152, 198, 0.5) !important; border-radius:4px !important; height:40px !important;"
    [min]="1"
    [max]="totalPages"
    (keydown.enter)="goToPage()" *ngIf="totalPages > limit"
  />
  </div>
    <div class="col-12 col-sm-8 col-md-9 pages">
      <nav *ngIf="totalPages > 1">
        <ul class="pagination justify-content-end align-items-center">
          <!-- First Page -->
          <li class="page-item" [class.disabled]="currentPage === 1">
            <a class="page-link" (click)="changePage(1)" title="First page">«</a>
          </li>
          <!-- Previous Group (only if totalPages >= 10) -->
          <li
            class="page-item"
            *ngIf="totalPages >= itemsPerPage"
            [class.disabled]="!hasPreviousGroup"
          >
            <a class="page-link" (click)="goToPreviousGroup()">‹</a>
          </li>
      
          <!-- Page Numbers -->
          <li
            *ngFor="let page of visiblePages"
            class="page-item"
            [class.active]="page === currentPage"
          >
            <a class="page-link" (click)="changePage(page)">{{ page }}</a>
          </li>
      
          <!-- Next Group (only if totalPages >= 10) -->
          <li
            class="page-item"
            *ngIf="totalPages >= itemsPerPage"
            [class.disabled]="!hasNextGroup"
          >
            <a class="page-link" (click)="goToNextGroup()">›</a>
          </li>
      
          <!-- Last Page -->
          <li class="page-item" [class.disabled]="currentPage === totalPages">
            <a class="page-link" (click)="changePage(totalPages)" title="Last Page">»</a>
          </li>
        </ul>
      </nav>
      
    </div>
</div>

 